import FrodSelectPage from 'components/Frod/FrodSelectPage/FrodSelectPage';
import { FrodPageContainer } from './FrodPage.styled';
import { useEffect, useState } from 'react';
import FrodWorkPart from 'components/Frod/FrodWorkPart/FrodWorkPart';
import FrodDocuments from 'components/Frod/FrodDocuments/FrodDocuments';
import { useSelector } from 'react-redux';
import { selectUserConfig } from '../../redux/selectors';

const FrodPage = ({ isRequest, selectedValues, updateSelectedValues }) => {
  // const [selectedProject, setSelectedProject] = useState(null);
  // const [selectedShift, setSelectedShift] = useState(null);

  // const config = useSelector(selectUserConfig);

  // const project = config?.project;
  // const shiftType = config?.shift_type;

  return (
    <>
      <FrodWorkPart />
    </>
  );
};

export default FrodPage;
